import {userConstants} from '../constants/user.constants.js';
import {
  VIEW_MORE_CHECKIN_BOOKING,
  VIEW_MORE_CHECKOUT_BOOKING,
  VIEW_MORE_CLAIMED_BOOKING,
  VIEW_MORE_RESERVE_BOOKING,
} from '../constants';

const initialState = {};

export const bookings = (state = initialState, action) => {
  switch (action.type) {
    case userConstants.LOY3_GET_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload,
        pagination: 5,
        reserveShown: 5,
        checkinShown: 5,
        checkoutShown: 5,
        claimedShown: 5,
      }
    case userConstants.LOY3_FIND_BOOKING_SUCCESS || userConstants.LOY3_CLAIM_BOOKING_SUCCESS:
      return {
        ...state,
        status: action.status
      }
    case userConstants.LOY3_CLAIM_BOOKING_WITH_PDF_SUCCESS:
      return {
        ...state,
        uploadStatus: action.response
      }
    case VIEW_MORE_RESERVE_BOOKING:
      return {
        ...state,
        reserveShown: state.reserveShown + 5
      }
    case VIEW_MORE_CHECKIN_BOOKING:
      return {
        ...state,
        checkinShown: state.checkinShown + 5
      }
    case VIEW_MORE_CHECKOUT_BOOKING:
      return {
        ...state,
        checkoutShown: state.checkoutShown + 5
      }
    case VIEW_MORE_CLAIMED_BOOKING:
      return {
        ...state,
        claimedShown: state.claimedShown + 5
      }
    case userConstants.LOGOUT:
      return initialState
    default:
      return state
  }
};
